import { Link } from "react-router-dom"
import styled from "styled-components"
import { Button } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
`

const Title = styled.h3`
  margin: 0;
`

const Subtitle = styled.p`
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`

export type NewSubscriptionRequiredProps = {}

const NewSubscriptionRequired: React.FC<NewSubscriptionRequiredProps> = () => {
  const translations = useTranslate({
    title: "new-subscription-required.title",
    description: "new-subscription-required.description",
    buyNew: "subscription-cancelled.buy-new",
  })

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Subtitle>{translations.description}</Subtitle>
        <Link to="/subscription/buy-new-subscription">
          <Button>{translations.buyNew}</Button>
        </Link>
      </Card>
    </Layout>
  )
}

export default NewSubscriptionRequired
